<template>
  <div class="footer" :style="`background: ${entityConfig.primaryColor}`">
    <v-container>
      <div class="row py-3" style="text-align: center">
        <v-col cols="12" sm="3" md="2" lg="2">
          <img
            :src="entityConfig.footer1LogoUrl"
            class="header-brand-img centrado-img"
            alt="logo"
            width="170"
          />
        </v-col>
        <v-col cols="12" sm="6" md="8" lg="8">
          <div class="row">
            <div class="col-sm-12" style="text-align: center">
              <a
                :href="entityConfig.legalNoticeUrl"
                class="link-footer"
                target="_blank"
                >Aviso legal</a
              >
              <a
                :href="entityConfig.cookiePolicyUrl"
                class="link-footer"
                target="_blank"
                >Política de cookies</a
              >
              <a
                :href="entityConfig.privacyPolicyUrl"
                class="link-footer"
                target="_blank"
                >Política de privacidad</a
              >
            </div>

            <div class="col-sm-12 pt-2" style="text-align: center">
              <small class="copyright"
                >&copy; {{ entityConfig.copyrightNotice }} {{ year }}. Todos los
                derechos reservados.</small
              >
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="3" md="2" lg="2">
          <img
            :src="entityConfig.footer2LogoUrl"
            class="header-brand-img centrado-img"
            alt="logo"
            width="170"
          />
        </v-col>
      </div>

    </v-container>
  </div>
</template>

<style scoped lang="scss">
@import "./footer-style";
</style>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      entityConfig: {},
    };
  },
  mounted() {
    let codNrbeEn = window.sessionStorage.getItem('codNrbeEn');
    let timeout = (!(codNrbeEn) || codNrbeEn === 'undefined') ? 1200 : 500;
    setTimeout(() => {
      this.entityConfig = this.$store.state.entityConfig.config;
    }, timeout);
  },
  computed: {
    year() {
      return new Date().getUTCFullYear();
    },
  },
};
</script>
